<div class="game-limits__container--title">
    <p>{{'SETTINGS.GAME_LIMITS' | translate}}</p>
</div>
<div class="game-limits__container--content">
    <p>{{'MIN_BET' | translate}} {{data.minBet | balance:true:true}}</p>
    <p>{{'MAX_BET' | translate}} {{data.maxBet | balance:true:true}}</p>
    <p>
        <span>{{'MAX_WIN_AMOUNT' | translate}} {{data.maxWinAmount | balance:true:true}}</span>
        <span class="description">{{'MAX_WIN_AMOUNT_DESCRIPTION' | translate}}</span>
    </p>
    <p class="multiplier">{{'MAX_MULTIPLIER' | translate}} {{data.maxMultiplier | formatNumber:true}}</p>
</div>
